import { Box, Divider, Grid } from "@mui/material";
import { MenusProps } from "..";
import { escurecerCor } from "../../../../helpers/manipulacaoCores";
import { colors } from "../../bannerColors";
import TemplateOpcoes from "../../Templates/TemplateOpcoes";
import AddIcon from "@mui/icons-material/Add";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import TemplateDashboardComOpcoes from "../../Templates/TemplateDashboardComOpcoes";
import { useModalStateContext } from "../../../../contexts/ModalStateContext";
import { usePermission } from "../../../PermissionGuard";

export default function ComercialMenu({ type }: MenusProps) {
  const navigate = useNavigate();

  const color = colors[type] || "#1E2E6B";
  const textColor = escurecerCor(color);

  const { handleToggleModal } = useModalStateContext();

  const handleRedirect = (path: string) => {
    navigate(`/comercial/${path}`);
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <TemplateDashboardComOpcoes
          {...{ type }}
          color={textColor}
          items={[
            {
              label: "Configurações",
              icon: <SettingsIcon fontSize="inherit" />,
              action: () => handleRedirect("configuracoes"),
              disabled: !usePermission("comercial.configuracoes"),
            },
          ]}
        />

        <Divider
          orientation="vertical"
          sx={{ border: "1px solid", borderColor: "divider" }}
          flexItem
        />

        <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Pedidos"
            color={textColor}
            items={[
              {
                label: "Criar pedido",
                icon: <AddIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal("comercial", "criarPedidoVenda", true),
                disabled: !usePermission("comercial.criar-pedido"),
              },
              {
                label: "Listar todos",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("pedidos/listar-todos"),
                disabled: !usePermission('comercial.listar-pedidos'),
              },
              {
                label: "Resumo operações",
                icon: <ShowChartOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("pedidos/resumo-operacoes"),
                disabled: !usePermission("comercial.resumo-operacoes"),
              },
            ]}
          />

          <TemplateOpcoes
            title="Devoluções"
            color={textColor}
            items={[
              {
                label: "Abrir solicitação",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Listar solicitações",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("devolucoes/listar-solicitacoes"),
                disabled: !usePermission("comercial.devolucoes"),
              },
            ]}
          />
        </Grid>

        <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Produtos"
            color={textColor}
            items={[
              {
                label: "Incluir produto",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Listar todos",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("produtos/listar-todos"),
                disabled: !usePermission("comercial.produtos"),
              },
            ]}
          />

          <TemplateOpcoes
            title="Notas fiscais"
            color={textColor}
            items={[
              {
                label: "Emitir nota fiscal",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Listar todas",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("notas-fiscais/listar-todas"),
                disabled: !usePermission("comercial.notas-fiscais"),
              },
            ]}
          />
        </Grid>

        <Grid container size={{md: 2.3}} spacing={2} alignSelf={"flex-start"}>
          <TemplateOpcoes
            title="Vendedores"
            color={textColor}
            items={[
              {
                label: "Incluir vendedor",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Listar todos",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("vendedores/listar-todos"),
                disabled: true,
              },
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
